import { createSelector } from 'reselect';
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';

import {
  //REQUESTS_FOR_GLOBAL_INDICATOR,
  REQUESTS_FOR_LOGIN_INDICATOR,
  REQUESTS_FOR_DATA_SETS_PAGE,
  REQUESTS_FOR_SAMPLES_LOADING,
} from '../../constants/requestTypes';

import {
  SET_REQUEST_IN_PROCESS,
  SET_REQUEST_PROGRESS,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

const initialState = { progress: {} };

export const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REQUEST_IN_PROCESS:
      return setRequestInProcess(state, action);

    case SET_REQUEST_PROGRESS:
      return setRequestProgress(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default requestReducer;

function setRequestInProcess(state, action) {
  const { inProcess, requestType } = action;
  const newState = {
    ...state,
    [requestType]: inProcess,
  };

  if (!inProcess && state.progress[requestType]) {
    const newProgress = { ...state.progress };
    delete newProgress[requestType];
    newState.progress = newProgress;
  }

  return newState;
}

function setRequestProgress(state, action) {
  const { loaded, total, requestType } = action;

  return {
    ...state,
    progress: {
      ...state.progress,
      [requestType]: { loaded, total },
    },
  };
}

const getAllRequests = (state) => state.request;

export const getGlobalRequestStatus = createSelector(getAllRequests, (allRequests) => {
  let isLoading = false;
  forEach(allRequests, (status, req) => {
    if (status === true) {
      isLoading = true;
      return false;
    }
  });
  return isLoading;
});

export const getLoginRequestStatus = createSelector(getAllRequests, (allRequests) => {
  let isLoggingIn = false;

  forEach(allRequests, (status, req) => {
    if (includes(REQUESTS_FOR_LOGIN_INDICATOR, req) && status === true) {
      isLoggingIn = true;
      return false;
    }
  });

  return isLoggingIn;
});

export const getDataSetsPageRequestStatus = createSelector(getAllRequests, (allRequests) => {
  let isLoadingDataSets = false;

  forEach(allRequests, (status, req) => {
    if (includes(REQUESTS_FOR_DATA_SETS_PAGE, req) && status === true) {
      isLoadingDataSets = true;
      return false;
    }
  });

  return isLoadingDataSets;
});

export const getSamplesRequestStatus = createSelector(getAllRequests, (allRequests) => {
  let isFetchingSamples = false;
  forEach(allRequests, (status, req) => {
    if (includes(REQUESTS_FOR_SAMPLES_LOADING, req) && status === true) {
      isFetchingSamples = true;
      return false;
    }
  });
  return isFetchingSamples;
});
